import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CsrfTokenService } from './csrf-token.service';

@Injectable({
  providedIn: 'root'
})
export class CsrfDoubleSubmitTokenService extends CsrfTokenService {
  private static readonly _csrfCookieName = 'csrftoken';

  constructor(
    private _cookieService: CookieService
  ) {
    super();
  }

  set(_token: string): void {}

  get needsCsrfTokenRequest(): boolean {
    return !this._cookieService.check(CsrfDoubleSubmitTokenService._csrfCookieName);
  }

  protected _readTokenValue(): string {
    return this._cookieService.get(CsrfDoubleSubmitTokenService._csrfCookieName);
  }
}
